<template>
  <div style="margin-top:50px;">
   <div id="editorjs"></div>
    <v-row class="editor-row">
      <v-col cols='12'>
        <v-btn
         :loading="loading"
         :disabled="loading"       
         color="blue-grey"
         class="ma-1 white--text"
         @click='download'
         >Download
        <v-icon right dark>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn class="ma-1" color='primary' width='200' @click='save'>Save</v-btn>      
        <v-btn class="ma-1" right @click="cancelClick">
        Close
        </v-btn>  
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" color="success" rounded="pill" :timeout="snackbarTimeout">     
      {{snackbarText}}
      <template v-slot:action="{ snackattrs }">
        <v-btn
          color="white"
          text
          v-bind="snackattrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>  
  </div>
</template>
<style>
.editor-row {
  position: fixed;
  text-align:right;
  margin-right: 50px!important;
  margin-right: 10px!important;
  bottom: 0;
  right: 0;
  z-index: 1000;
}
.brief-image {
    padding: 20px 0;
}

.brief-image input {
    width: 100%;
    padding: 10px;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    outline: none;
    font-size: 14px;
}

.brief-image img {
    max-width: 100%;
    width: 350px;
    margin-bottom: 15px;
}

.brief-image.withBorder img {
    border: 1px solid #e8e8eb;
}

.brief-image.withBackground {
    background: #eff2f5;
    padding: 10px;
}

.brief-image.withBackground img {
    display: block;
    max-width: 60%;
    margin: 0 auto 15px;
}

.ce-block__content,
.ce-toolbar__content {
    max-width: 850px;
}

.codex-editor__redactor {
    padding-bottom: 100px !important;
}

</style>
<script>
/* eslint-disable */
import api from '@/api'
import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import listBlock from '@editorjs/list'
import RenderImage from './plugin/renderImage'
import Underline from '@editorjs/underline'
import Delimiter from '@editorjs/delimiter'

import pairingAPIs from '../../components/views/Pairing/pairingAPIs'

import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../components/views/Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
import BlocksToPDF from '../editor/generator/blocksToPDF'

export default {
  name: 'editorjs_vue',
  props: ['content', 'pairingID', 'userID', 'saveStatus', 'reportName'],
  data() {
    return {              
      editorData: {},
      loader: null,
      loading: false,
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: ''
    }
},
watch: {
    content: {
     handler: function(val, oval) {      
      //  console.log('Editor blocks', val)      
        editor.render ({           
            blocks: val.blocks
        })
        // this.content.blocks = val.blocks
     },
     deep: true
    },    
    loader() {
     const l = this.loader
     this[l] = !this[l]

     this.loader = null
    },
    async saveStatus() {
      await this.save()
    }
},
mounted() {
  let token = localStorage.getItem('token')
    window.editor = new EditorJS({
        holder: 'editorjs',
        tools: {
            header: {
                class: Header,
                config: {
                    placeholder: 'Enter a header'
                }
            },            
            image: RenderImage,            
            list: {
                class: listBlock,
                inlineToolbar: true
            },
            underline: Underline,
            delimiter: Delimiter
        },
        data: this.content,
        inlineToolbar: true,
        onChange: (blk) => {
          // let blockCount = blk.getBlocksCount()    
          let previousBlocksCount = this.content.blocks.length;
          let currentBlocksCount = blk.blocks.getBlocksCount()
          // console.log('Current Blocks index', blk.blocks.getCurrentBlockIndex())
          // console.log('Current Blocks', blk.blocks.getBlockByIndex(blk.blocks.getCurrentBlockIndex()))
          if (previousBlocksCount !== currentBlocksCount )
            this.$emit('contentChangeTrue')
          else this.$emit('contentChangeFalse')
        }
    })  
    setTimeout(function() {
      pdfMake.fonts = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      }
    }, 1000);
  },
methods: {
    deleteImages(url) {      
      let filename = url.substring(url.lastIndexOf('/') + 1)
      // console.log('Removed file name', filename)
      api.request('delete', '/api/v1/posts/s3/delete', true, {image: filename})
      //console.log('Delete response', response)
    },
    checkDeletedImages(currentBlocks) {
      let blocksArray = JSON.parse((JSON.stringify(this.content.blocks)))
      // console.log("🚀 ~ file: editorjs.vue ~ line 139 ~ _checkDeletedImages ~ blocksArray", blocksArray)
      // console.log("🚀 ~ file: editorjs.vue ~ line 138 ~ _checkDeletedImages ~ currentBlocks", currentBlocks)      

      for (let i=0; i<blocksArray.length; i++) {
        if (blocksArray[i].type === 'image') {
        
          if (currentBlocks[i] === undefined || currentBlocks[i] === null) {            
            this.deleteImages(blocksArray[i].data.url)
          }                 
        }
      }
    },
    async save() {           
      window.editor.save().then((res) => {
        let data = {
            pairingID: this.pairingID,
            userID: this.userID,
            content: res.blocks
        }
        // console.log('Editor Save data', res.blocks)
        this.checkDeletedImages(data.content)
        pairingAPIs.updatePairingBriefDetails(data).then(() => {            
            this.content.blocks = res.blocks
            this.$emit('contentChangeFalse')
            this.$emit('reloadDataTable')
            this.$emit('forceSaveOnCloseFalse')        
        })
        this.snackbarText = 'Successfully, Saved!'
        this.snackbar = true
      })
    },    
    async download() { 
      this.loader = 'loading'      
      const blocksToPdf = new BlocksToPDF(this.content.blocks, 'Arial')
      let pdfData = await blocksToPdf.generate()
      // console.log('PDF Data', pdfData)     
      pdfMake.createPdf(pdfData).download(this.reportName + 'brief.pdf');
      this.loading = false
    },
    cancelClick() {
      this.$emit('closeModal')
    }
  }  
}
</script>


// WEBPACK FOOTER //
// editorjs.vue?004d9ca2